import { Timeline, TimelineConnector, TimelineContent, TimelineItem, TimelineSeparator } from './TimeLine.styled'

export interface TimeLineItem {
  LabelComponent: () => JSX.Element
  DotComponent?: () => JSX.Element
}

interface TimeLineProps {
  items: TimeLineItem[]
}

export const TimeLine: React.FC<TimeLineProps> = ({ items }: TimeLineProps) => {
  return (
    <Timeline>
      {items.map((item, index) => {
        const nextItem = items[index + 1]
        const showSeparator = nextItem?.DotComponent

        return (
          <TimelineItem key={index}>
            {item.DotComponent && (
              <TimelineSeparator>
                <item.DotComponent />
                {showSeparator && <TimelineConnector isLast={index === items.length - 1} />}
              </TimelineSeparator>
            )}
            <TimelineContent>
              <item.LabelComponent />
            </TimelineContent>
          </TimelineItem>
        )
      })}
    </Timeline>
  )
}
